import {Component, Input, OnInit} from '@angular/core';
import {EventItem,TOAST_STATE} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {
  ActionService,
  AuthenticationService,
  LoaderService,
  ToastService, UserEventsService
} from "@services";
import {AbstractComponent} from "../abstract.component";
import {
  LOGIN_ROUTE,
  MY_TRACEY_FAVORITES,
} from "../../app-routing.module";
import {Router} from "@angular/router";
import {MyTraceyDataStore} from "@store";
import {EMPTY, finalize, switchMap} from "rxjs";

@Component({
    selector: 'app-favorite-event-indicator',
    templateUrl: './favorite-event-indicator.component.html',
    styleUrls: ['./favorite-event-indicator.component.scss'],
    standalone: false
})
export class FavoriteEventIndicatorComponent extends AbstractComponent implements OnInit {
  @Input() asButton: boolean = true;
  @Input() eventItem?: EventItem;
  @Input() isPreviewComponent?: boolean;
  @Input() isXsComponent?: boolean = false;
  favoriteItems?: EventItem[];

  constructor(
    public translocoService: TranslocoService,
    private userEventsService: UserEventsService,
    private myTraceyDataStore: MyTraceyDataStore,
    private loaderService: LoaderService,
    private toastService: ToastService,
    private authenticationService: AuthenticationService, private router: Router,
    private actionService: ActionService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.push(this.myTraceyDataStore.allFavorites$.subscribe(favoriteEvents => {
      this.favoriteItems = favoriteEvents;
    }));
  }

  get isAuthenticated(): boolean {
    return this.authenticationService.isAuthenticated();
  }

  isFavorite(): boolean {
    return !!this.favoriteItems?.find(value => this.eventItem?.id === value.id);
  }

  addToFavoritesButtonClicked(event: MouseEvent): void {
    if (this.isPreviewComponent) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (this.authenticationService.isAuthenticated()) {
      this.addToFavoritesAction();
    } else {
      this.toastService.showToast(TOAST_STATE.warning, this.translocoService.translate("event.saved.save.warning"));
      this.actionService.addAction(() => {
        this.addToFavoritesAction();
        this.router.navigate([MY_TRACEY_FAVORITES]);
      });
      this.router.navigate([LOGIN_ROUTE]);
    }
  }


  addToFavoritesAction() {
    if (!this.eventItem?.id) return;

    this.loaderService.startLoading();
    const action = this.isFavorite()
        ? this.userEventsService.removeEventFromFavorites(this.eventItem.id)
        : this.userEventsService.addEventToFavorites(this.eventItem.id);

    action.pipe(
            switchMap(actionResult => {
              if (!actionResult.result) {
                return EMPTY;
              }

              this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate(
                      this.isFavorite()
                          ? "event.saved.delete.success"
                          : "event.saved.save.success"
                  )
              );
              return this.myTraceyDataStore.initAllFavorites();
            }),
            finalize(() => {
              this.loaderService.dismissLoading();
            })
        )
        .subscribe();
  }

}
